<app-header [withBanner]="true"></app-header>
<app-landing-system-img *ngIf="browserService.isBrowser" titleHero="¿Cómo funciona {{system.attributes.name}}?" [system]="system"
    urlImage="assets/images/landing-system/hero-landing-system.png"></app-landing-system-img>

<div class="rs-wrapper-v4">
    <app-resume-system *ngIf="browserService.isBrowser" [system]="system" [defaultSystems]="defaultSystem" [countryName]="countryName"></app-resume-system>

    <h3 class="title-info-general">Tendencias del mercado</h3>
    <app-empty-component *ngIf="!system.attributes.can_receive || !systemHasData || !marketData"
        text="{{'Esta sección proporciona datos sobre la distribución del volumen de dinero que se mueve con ' + system.attributes.name + ', la actividad de los últimos 10 días y el sentimiento del mercado (compra o venta).'}}"></app-empty-component>
    <div *ngIf="system.attributes.can_receive && systemHasData && marketData" class="grid col3 col1-sm" #MarketTrend>
        <app-market-trend title="Distribución del volumen"
            tooltipInfo="En este gráfico observarás la cantidad de pedidos realizados exitosamente en la última semana y/o mes.">
            <ng-container>
                <app-system-activity-card [system]="system"></app-system-activity-card>
            </ng-container>
        </app-market-trend>

        <app-market-trend title="Actividad en los últimos 10 días"
            tooltipInfo="Aquí puedes observar la cantidad de transferencias y pedidos exitosos coordinados globalmente en los últimos 10 días.">
            <ng-container>
                <div class="card-activity">
                    <div class="container-text-activity">
                        <div>
                            <p class="text-activity">Transferencias <br>coordinadas <br></p>
                            <p class="number-activity">{{coordinatedTransfers}}</p>
                        </div>
                        <div>
                            <p class="text-activity">Pedidos exitosos </p>
                            <p class="number-activity">{{sentTransaction}}</p>
                        </div>
                    </div>
                    <app-map-system-activity></app-map-system-activity>
                </div>
            </ng-container>
        </app-market-trend>

        <app-market-trend title="Sentimiento del mercado"
            tooltipInfo="El gráfico de la derecha te dará un indicio de cuándo es el mejor momento para comprar, vender o intercambiar tu dinero, mientras que el gráfico de la izquierda te indicará que a mayor volumen, más rápido se procesará tu pedido.">
            <ng-container>
                <app-gradient-system
                    *ngIf=" system.relationships.system_information.builded && system.relationships.system_information.data[0]"
                    [valueTrend]="system.attributes.trend"
                    [valueVolume]="system.relationships.system_information.data[0].attributes.volume"
                    [system]="system"></app-gradient-system>
            </ng-container>
        </app-market-trend>
    </div>

    <div class="container-payment-queue" *ngIf="browserService.isBrowser">
        <app-payment-queue [system]="system" [paymentId]="paymentId"></app-payment-queue>
    </div>

    <div style="margin-top: 62px;" *ngIf="system.relationships.networks.data.length">
        <app-networks-system [system]="system"></app-networks-system>
    </div>

    <div [ngClass]="{'padding-empty': !system.attributes.can_receive || !systemHasData || !marketData}">
        <h3 class="title-deals-landing-system">Atrapa ofertas y paga hasta un 5% menos</h3>
        <app-empty-component *ngIf="!system.attributes.can_receive || !systemHasData || !marketData"
            text="En esta sección generalmente ofrecemos oportunidades para adquirir montos de saldo con descuentos especiales."></app-empty-component>
        <div class="block-of-public-deals" *ngIf="system.attributes.can_receive && systemHasData && marketData">
            <app-public-deals [showMoreInfo]="false" [system]="system" buyOrSell="buy"
                title="Compra Saldo {{system.attributes.name}}">
            </app-public-deals>
            <app-public-deals [showMoreInfo]="true" [filterPublicDealsBySystem]="system.id" buyOrSell="sell"
                title="Vende Saldo {{system.attributes.name}}">
            </app-public-deals>
        </div>
    </div>

    <div style="margin-top: 62px;">
        <app-blog-by-system style="margin-top: 62px;" [system]="system" [systemTags]="tagsBlog"
            title="Blog de Saldoar : {{system.attributes.name}}">
        </app-blog-by-system>
    </div>

    <app-systems-alternatives [system]="system" [systemsId]="alternativeSystem">
    </app-systems-alternatives>
</div>

<app-footer></app-footer>
